import moment from 'moment'

export function createJobDayCards(jobDays) {

    let cards = []

    jobDays.forEach(jobDay => {

        cards.push({
            id: jobDay.id,
            date: moment(jobDay.date).format("MM/DD/YYYY"),
            startTime: moment(`${jobDay.date} ${jobDay.startTime}`).format("hh:mm A"),
            numCrewMembers: jobDay.crewMemberAssignments.length
        })

    })

    return cards
}